export const AORIST = "Aorist";
export const OPEN_SEA = "Open Sea";
